import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { TranslocoModule } from '@jsverse/transloco';


@Component({
    selector: 'app-error-snackbar',
    templateUrl: './error-snackbar.component.html',
    styleUrls: ['./error-snackbar.component.scss'],
    imports: [TranslocoModule]
})
export class ErrorSnackbarComponent implements OnInit {
  data = inject<{
    title: string;
    details: string | undefined;
}>(MAT_SNACK_BAR_DATA);


  title: string;
  details: string | undefined



  constructor() {
    const data = this.data;

    console.log(data)
    this.title = data.title;
    this.details = data.details
  }

  ngOnInit(): void {
  }

}
